/* eslint-disable */

import axios from "axios";
import { make } from "vuex-pathify";
import moment from "moment";
import { tz } from "../../../utils/timezone";
import momentTz from "moment-timezone";

const url = require("../../client_config/config").url;

const state = {
  allMedications: [],
  allClientMedications: [],
  medications: [],
  medication: {},
  MAR: [],
  morning: [],
  afternoon: [],
  evening: [],
  PRN: [],
  selectedItem: [],
  isSelectedMultipleItem: false,
  isSaving: false,
  dialog: null,
  isLoading: false,
  isDisableButton: true,
  confirmedDialog: false,
};

const getters = {
  getMAR: (state) => state.MAR,
  getSelectedItemSize: (state) => state.selectedItem.length,
  getAllClientMedications: (state) => {
    return state.allClientMedications.map((item) => {
      let tempDaysOfWeek = item.DaysOfWeek;
      let tempIntervalDays = item.IntervalDays;
      let tempDaysOfMonth = item.DaysOfMonth;

      let checkTodayDayOfWeek = true;
      let checkIntervalDays = true;
      let checkDaysOfMonth = true;

      //DISPLAYING DAYS OF WEEK
      if (tempDaysOfWeek.length > 0) {
        if (tempDaysOfWeek[0] !== "") {
          checkTodayDayOfWeek = false;
          let dayToday = moment(Date.now()).format("dddd");
          let dayOfWeek = tempDaysOfWeek.filter(function(elem) {
            if (elem == dayToday) return elem;
          });
          if (dayOfWeek.length > 0) checkTodayDayOfWeek = true;
        }
      }

      // //DISPLAYING DAYS OF MONTH
      if (tempDaysOfMonth.length > 0) {
        if (tempDaysOfMonth[0] !== "") {
          checkDaysOfMonth = false;
          let numDayToday = moment(Date.now()).format("D");
          let dayOfMonth = tempDaysOfMonth.filter(function(elem) {
            if (elem == numDayToday) return elem;
          });
          if (dayOfMonth.length > 0) checkDaysOfMonth = true;
        }
      }

      //DISPLAYING INTERVAL DAYS
      if (tempIntervalDays.length > 0) {
        if (tempIntervalDays[0] !== "") {
          let intervalStartDate = moment(item.StartDate).subtract(tempIntervalDays, 'd').format("YYYY-MM-DD");
          let intervalEndDate = moment(item.EndDate).format("YYYY-MM-DD");
          let dateIntervalNow = moment(Date.now()).format("YYYY-MM-DD");
          let intervalDay = item.IntervalDays;

          let intervalDaysDuration = moment
            .duration(
              moment(intervalEndDate, "YYYY-MM-DD").diff(
                moment(intervalStartDate, "YYYY-MM-DD")
              )
            )
            .asDays();
          checkIntervalDays = false;
          let calculateInterval =
            parseInt(intervalDaysDuration) / parseInt(intervalDay);
          const intervalDates = [];

          for (let i = 0; i < calculateInterval; i++) {
            let getIntervalDays = moment(intervalStartDate, "YYYY-MM-DD")
              .add(intervalDay, "days")
              .format("YYYY-MM-DD");
            intervalStartDate = getIntervalDays;
            intervalDates.push(getIntervalDays);
          }

          let checkIntervalDay = intervalDates.filter(function(value) {
            if (value == dateIntervalNow) return value;
          });

          if (checkIntervalDay.length > 0) checkIntervalDays = true;
        }
      }

      if (
        checkTodayDayOfWeek === true &&
        checkDaysOfMonth === true &&
        checkIntervalDays === true
      ) {
        return {
          ...item,
          newTime: moment(item.AdminTime, ["h:mm A"]).format("H"),
          newItem: item.Medication,
        };
      }
    });
  },
};

const actions = {
  async fetchMedications({ commit }) {
    try {
      const response = await axios.get(`${url}/medications/`);
      commit("SET_MEDICATIONS", response.data);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  // Get all medication admin time
  async getAllMedications({ commit }, id) {
    try {
      const response = await axios.get(`${url}/medications/${id}/time`);
      commit("SET_ALL_MEDICATIONS", response.data);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async fetchAllClientMedications({ commit }, id) {
    let tz = momentTz.tz.guess();
    try {

      const response = await axios.get(`${url}/medications/all/med/${id}`, {
        params: { tz },
      });
      commit("SET_ALL_CLIENT_MEDICATIONS", response.data.medications);
      return response.data.medications;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async getAllClientsMeds({ commit }, data) {
    let tz = momentTz.tz.guess();
    try {
      const response = await axios.get(`${url}/medications/all/clients/med`, {
        params: { tz, clientIds:  data},
      });
      return response.data;
    } catch (error) {
      console.log(error);
      return error;
    }
  },

  async getSpecificMedication({ commit }, { id, clientId, time }) {
    try {
      const response = await axios.get(
        `${url}/medications/specific/${id}/${clientId}/${time}`
      );
      commit("SET_ALL_SPECIFIC_MEDICATION", response.data);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async fetchMAR({ commit }, data) {
    try {
      const response = await axios.get(`${url}/MAR/${data.id}`);
      const mars = response.data.mar.map((item) => {
        item.Date = moment(item.Date).format("YYYY-MM-DD");
        return {
          ...item,
          Date: tz(item.Date, data.userTimezone).format("YYYY-MM-DD"),
        };
      });

      commit("SET_MAR", mars);
      return response;
    } catch (error) {
      console.error(error);
      return error;
    }
  },

  async addMultipleMAR({ commit }, data) {
    try {
      const response = await axios.post(`${url}/MAR/multiple/`, data);
      return response;
    } catch (error) {
      return error;
    }
  },

  addSelectedItem({ commit }, data) {
    try {
      commit("SET_SELECTED_ITEM", data);
    } catch (error) {
      console.log(error);
    }
  },

  updateSelectedItem({ commit }, data) {
    try {
      commit("SET_UN_SELECTED_ITEM", data);
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  ...make.mutations(state),
  SET_MEDICATIONS(state, data) {
    state.allMedications = data;
  },
  SET_MEDICATIONS(state, data) {
    state.medications = data;
  },
  SET_ALL_CLIENT_MEDICATIONS(state, data) {
    state.allClientMedications = data;
  },
  SET_MAR(state, data) {
    state.MAR = data;
  },
  SET_MORNING_MEDICATION(state, data) {
    state.morning = data;
  },
  SET_AFTERNOON_MEDICATION(state, data) {
    state.afternoon = data;
  },
  SET_EVENING_MEDICATION(state, data) {
    state.evening = data;
  },
  SET_PRN_MEDICATION(state, data) {
    state.PRN = data;
  },
  SET_ALL_SPECIFIC_MEDICATION(state, data) {
    state.medication = data;
  },
  SET_IS_SAVING(state, data) {
    state.isSaving = data;
  },

  SET_LOADING(state, data) {
    state.isLoading = data;
  },

  SET_DISABLE_BUTTON(state, data) {
    state.isDisableButton = data;
  },

  SET_IS_SELECTED_MULTIPLE_ITEM(state, data) {
    state.isSelectedMultipleItem = data;
  },

  SET_SELECTED_ITEM(state, data) {
    let isExist = state.selectedItem.some(
      (item) => item.generatedId === data.generatedId
    );

    if (!isExist) {
      state.selectedItem.push(data);
    }
  },

  SET_UN_SELECTED_ITEM(state, data) {
    let itemIndex = state.selectedItem.indexOf(data.generatedId);
    state.selectedItem.splice(itemIndex, 1);
  },

  SET_DIALOG(state, data) {
    state.dialog = data;
  },

  SET_CONFIRMED_DIALOG(state, data) {
    state.confirmedDialog = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
